<template>
  <div
    style="font-size: 12px"
    class="webview"
    :class="{ 'webview--dark': darkMode }"
    v-html="html"
  ></div>
</template>
<script setup>
import { ref } from "vue";
import { useRoute } from "vue-router";
import api from "../api";
import Ditto from '@zeekr-f2e/zeekr-ditto'
const route = useRoute();
const clauseCode = route.params.id;
let html = ref("");
const darkMode = ref(false);
if (route.query && route.query.mode === "dark") {
  darkMode.value = true;
}
// 421459faa4e1f6d564f67d138620be8d为“极氪订阅”的md5字符串
if (
  (route.query && route.query.token === "421459faa4e1f6d564f67d138620be8d") ||
  /\/public\/TK002/i.test(route.fullPath)
) {
  api.post("/clause/action/queryOne", { params: { clauseCode } }).then(
    (res) => {
      if (res.status === 200 && res.data.code === "0") {
        document.querySelector("title").innerHTML = res.data.body.name;
        Ditto.changeWebViewTitle({
          text:	res.data.body.name,
          textColor:	"#fff",
          textSize:	"16",
        })
        html.value = res.data.body.clauseDetails;
      } else {
        html.value = "获取内容失败";
      }
    },
    () => {
      html.value = "获取内容失败";
    }
  );
} else {
  html.value = "您无权限查看";
}
</script>
<style scoped>
.webview {
  padding: 15px;
  font-family: "PingFang SC";
  width: 100vw;
  height: 100vh;
  overflow: auto;
  box-sizing: border-box;
}
.webview--dark {
  background: #0b0b0b;
  color: #fff;
}
::v-deep img {
  max-width: 100%;
}
</style>
